exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-margin[data-v-2190e477]{margin:10px 10px 10px 0}.cancan[data-v-2190e477],.draw-div[data-v-2190e477]{width:100%}.draw-div[data-v-2190e477]{background-color:#e6ffe9;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:stretch;align-self:stretch;justify-self:stretch}.anchor-top-left[data-v-2190e477]{position:absolute;top:0;left:0}", ""]);

// exports
